export function parseDuration(duration: unknown): number | null {
  if (duration === null || duration === undefined || duration === '') return null;
  if (typeof duration === 'number') return duration;
  const [hours, minutes, seconds] = (duration as string).split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function parseNumber(val: unknown): number | null {
  if (val === null || val === undefined) {
    return null;
  }

  if (typeof val === 'string') {
    const trimmed = val.trim();
    if (trimmed === '') {
      return null;
    }
    const normalized = trimmed.replace(',', '.');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  if (typeof val === 'number') {
    return Number.isFinite(val) ? val : null;
  }

  return null;
}

export function parseString(val: unknown): string | null {
  return typeof val === 'string' && val.trim() !== '' ? val : null;
}
